module.exports = __webpack_public_path__ + "img/oogvereniging-logo.012c80fb.png";